import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, NgForm, Validators} from '@angular/forms';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {EMPTY, interval, of, ReplaySubject, Subject, timer} from 'rxjs';
import {UserPermissions} from '../../../shared/interface/user-permissions';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthService} from '../../../shared/services/auth.service';
import {FilterService} from '../../../shared/services/filter.service';
import {ActivatedRoute, Router} from '@angular/router';
import {select, Store} from '@ngrx/store';
import {StoreRootState} from '../../../shared/ngrx/reducers';
import {catchError, delay, distinctUntilChanged, exhaustMap, finalize, map, startWith, switchMap, takeUntil, tap} from 'rxjs/operators';
import {CountedAndPaginated} from '../../../shared/interface/response/counted-and-paginated';
import {getCurrentRouteState} from '../../../shared/ngrx/selector';
import {RouterStateUrl} from '../../../shared/ngrx/route-serializer';
import {CommissionJobService} from '../../../shared/services/commission-job.service';
import {CommissionJob} from '../../../shared/interface/commission-job';
import moment from 'moment';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';
import {CommissionImport} from '../../../shared/interface/commission-import';
import {InsuranceCompany} from '../../../shared/interface/insurance-company';
import {CommissionImportService} from '../../../shared/services/commission-import.service';
import {Uuid} from '../../../shared/interface/response/uuid';
import {JobResultDialogComponent} from '../../../shared/components/job-result-dialog/job-result-dialog.component';
import {HttpErrorResponse} from '@angular/common/http';
import {CommissionImportRowService} from '../../../shared/services/commission-import-row.service';
import {CommissionSettlementService} from '../../../shared/services/commission-settlement.service';
import {CommissionImportRow} from "../../../shared/interface/commission-import-row";
import {
  COMMISSION_IMPORT_ROW_STATUS_ASSIGNED_ID,
  COMMISSION_IMPORT_ROW_STATUS_SETTLED_ID,
  COMMISSION_JOB_CLOSE_MONTH, COMMISSION_JOB_GENERATE_COMMISSION_STATEMENTS,
  COMMISSION_JOB_GENERATE_INVOICES,
  COMMISSION_JOB_GENERATE_SETTLEMENTS,
  COMMISSION_JOB_SEND_SETTLEMENTS_TO_PARTNERS,
  COMMISSION_JOB_STATUS_IN_ERROR,
  COMMISSION_JOB_STATUS_IN_PROGRESS,
  COMMISSION_JOB_STATUS_IN_SUCCESS,
  COMMISSION_JOB_STATUS_PENDING,
  CONTRACT_OWNER_OFWCA,
  CONTRACT_OWNER_PARTNER,
  CONTRACT_TYPE_PARTNERSHIP,
  CONTRACT_TYPE_PROFIT
} from "../../../shared/services/dict.service";
import {JobsListDialogComponent} from "../jobs-list-dialog/jobs-list-dialog.component";
import {Krk} from "../../../shared/interface/krk";
import {Notification} from "../../../shared/interface/notification";
import {FormHelperService} from "../../../shared/services/form-helper.service";
import {CommissionRedirectionLockService} from "../../../shared/services/commission-redirection-lock.service";
import {CommissionRedirectionLock} from "../../../shared/interface/commission-redirection-lock";
import {MatSlideToggleChange} from "@angular/material/slide-toggle";

@Component({
  selector: 'app-jobs-list',
  templateUrl: './jobs-list.component.html',
  styleUrls: ['./jobs-list.component.scss']
})
export class JobsListComponent implements AfterViewInit, OnInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  readonly COMMISSION_JOB_STATUS_IN_SUCCESS = COMMISSION_JOB_STATUS_IN_SUCCESS;
  readonly COMMISSION_IMPORT_ROW_STATUS_ASSIGNED_ID = COMMISSION_IMPORT_ROW_STATUS_ASSIGNED_ID;
  assignedId = COMMISSION_IMPORT_ROW_STATUS_ASSIGNED_ID;
  readonly COMMISSION_IMPORT_ROW_STATUS_SETTLED_ID = COMMISSION_IMPORT_ROW_STATUS_SETTLED_ID;
  readonly COMMISSION_JOB_STATUS_IN_PROGRESS = COMMISSION_JOB_STATUS_IN_PROGRESS;
  readonly COMMISSION_JOB_STATUS_PENDING = COMMISSION_JOB_STATUS_PENDING;
  readonly COMMISSION_JOB_GENERATE_SETTLEMENTS = COMMISSION_JOB_GENERATE_SETTLEMENTS;
  readonly COMMISSION_JOB_GENERATE_INVOICES = COMMISSION_JOB_GENERATE_INVOICES;
  readonly COMMISSION_JOB_CLOSE_MONTH = COMMISSION_JOB_CLOSE_MONTH;
  readonly COMMISSION_JOB_SEND_SETTLEMENTS_TO_PARTNERS = COMMISSION_JOB_SEND_SETTLEMENTS_TO_PARTNERS;
  readonly COMMISSION_JOB_STATUS_IN_ERROR = COMMISSION_JOB_STATUS_IN_ERROR;
  readonly COMMISSION_JOB_GENERATE_COMMISSION_STATEMENTS = COMMISSION_JOB_GENERATE_COMMISSION_STATEMENTS;

  commissionRedirectionLockControl: FormControl;

  commissionRedirectionLock: CommissionRedirectionLock = {
    active: false,
    billingMonth: null,
    unlockBillingMonth: null,
  };

  commissionRedirectionLockLoading = true;
  commissionRedirectionLockUpdating = false;


  initialFilters: any;
  jobs: CommissionJob[] = [];
  displayedColumns: string[] = [
    'billingMonth', 'parameters', 'description', 'createdAt', 'createdBy', 'result', 'status', 'actions',
  ];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;
  actionForm: FormGroup;
  billingMonthControl: FormControl;
  actionControl: FormControl;
  disable = false;
  actionKeyControl: FormControl;
  insuranceCompanyControl: FormControl;
  importControl: FormControl;
  ofwcaControl: FormControl;
  ownerControl: FormControl;
  overvoltageControl: FormControl;
  toGenerateControl: FormControl;
  partnerControl: FormControl;
  selectedInsuranceCompany?: InsuranceCompany = null;
  importListSubject: ReplaySubject<CountedAndPaginated<CommissionImport>>
    = new ReplaySubject<CountedAndPaginated<CommissionImport>>(1);
  closedSettlementsCount = 0;
  settlementsCount = 0;
  commissionSettlementCount = 0;
  commissionImportRowCount = 0;
  closed = true;
  adminRoot = false;
  formErrors = {};
  errors: any = {};

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  private listParams$ = new Subject<{
    page: number;
    pageSize: number;
    filters: any;
  }>();

  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
    private commissionJobService: CommissionJobService,
    private fb: FormBuilder,
    private commissionImportService: CommissionImportService,
    private commissionImportRowService: CommissionImportRowService,
    private commissionSettlementService: CommissionSettlementService,
    private formHelper: FormHelperService,
    private commissionRedirectionLockService: CommissionRedirectionLockService,

  ) {
    this.userPermissions = auth.getUserPermissions();
    this.commissionJobService.jobListSubject
      .pipe(
        takeUntil(this.destroyed$),
        tap((e: CountedAndPaginated<CommissionJob>) => {
          this.userPermissions.pipe().subscribe((user) => {
            // if (user.settlement?.admin_root === true){
              this.jobs = e.items;
            // } else {
            //   this.jobs = e.items.filter((job: CommissionJob) =>
            //     ![CONTRACT_OWNER_OFWCA, CONTRACT_OWNER_PARTNER].includes(job.owner?.key)
            //     && !job.overvoltage
            //   );
            // }
          });
          // this.jobs = e.items;
          this.totalData = e.pagination.total;
        })
      ).subscribe();
    this.parseFilters();

    const date = moment();
    date.startOf('month');
    date.subtract(1, 'month');
    this.billingMonthControl = fb.control(date, [Validators.required]);
    this.commissionRedirectionLockControl = fb.control(false);
    this.actionForm = fb.group({
      billingMonth: this.billingMonthControl,
      action: this.actionControl = fb.control('', [Validators.required]),
      actionKey: this.actionKeyControl = fb.control('', [Validators.required]),
      insuranceCompany: this.insuranceCompanyControl = fb.control(''),
      commissionImport: this.importControl = fb.control(''),
      ofwca: this.ofwcaControl = fb.control(''),
      owner: this.ownerControl = fb.control(''),
      overvoltage: this.overvoltageControl = fb.control(''),
      toGenerate: this.toGenerateControl = fb.control(''),
      partner: this.partnerControl = fb.control(''),
    });
    this.ownerControl.disable();
    this.overvoltageControl.disable();

    if (!this.toGenerateControl.value) {
      this.toGenerateControl.setValue(null, { emitEvent: false });
    }
    this.actionKeyControl.valueChanges
      .pipe(
        startWith(this.actionKeyControl.value),
        takeUntil(this.destroyed$),
      )
      .subscribe((value) => {
        const isSettlement = value === 'generateSettlements';
        const isCommission = value === 'generateCommissionStatements';

        if (isSettlement) {
          this.overvoltageControl.enable({ emitEvent: false });
          this.toGenerateControl.enable({ emitEvent: false });
          this.toGenerateControl.setValue(false, { emitEvent: false });
        } else {
          this.overvoltageControl.disable({ emitEvent: false });
          this.overvoltageControl.setValue(null, { emitEvent: false });

          this.toGenerateControl.disable({ emitEvent: false });
          this.toGenerateControl.setValue(null, { emitEvent: false });
        }

        if (isCommission) {
          this.ofwcaControl.disable({ emitEvent: false });
          this.ofwcaControl.setValue(null, { emitEvent: false });
        } else {
          this.ofwcaControl.enable({ emitEvent: false });
        }
      });
    // this.actionControl.valueChanges.pipe().subscribe((value) => {
    // if (value === 375) {
    //   this.overvoltageControl.enable();
    //   this.toGenerateControl.enable();
    //   this.toGenerateControl.setValue(false);
    //
    // } else {
    //   this.overvoltageControl.disable();
    //   this.overvoltageControl.setValue(null);
    //   this.toGenerateControl.disable();
    //   this.toGenerateControl.setValue(null);
    //
    // }
    // });
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
      action: 'int'
    }, filters);
  }

  ngOnInit(): void {
    // interval(1000)
    //   .pipe(takeUntil(this.destroyed$))
    //   .subscribe(() => {
    //     if (this.paginator.pageIndex === 0) {
    //       this.loadListData();
    //     }
    //   });

    this.billingMonthControl.valueChanges
      .pipe(
        map(value => value ? moment(value).format('YYYY-MM') : null),
        distinctUntilChanged(),
        takeUntil(this.destroyed$)
      )
      .subscribe((billingMonth) => {
        this.router.navigate([
          this.activatedRoute.snapshot.routeConfig.path,
          this.filterService.parseFiltersToQueryParams({
            page: 0,
            pageSize: this.paginator?.pageSize ?? 10,
            billingMonth,
            ...this.initialFilters,
          })
        ]);

        this.insuranceCompanyChanged(this.selectedInsuranceCompany);
      });
    this.loadCommissionRedirectionLock();
  }

  ngAfterViewInit(): void {
    this.userPermissions
      .pipe(takeUntil(this.destroyed$))
      .subscribe(() => {
        this.ownerControl.enable();
        this.overvoltageControl.enable();
        this.overvoltageControl.setValue(0);
      });

    this.paginator.page
      .pipe(takeUntil(this.destroyed$))
      .subscribe((event: PageEvent) => {
        this.router.navigate([
          this.activatedRoute.snapshot.routeConfig.path,
          this.filterService.parseFiltersToQueryParams({
            page: event.pageIndex,
            pageSize: event.pageSize,
            billingMonth: this.billingMonthControl.value,
            ...this.buildFilters()
          })
        ]);
      });

    this.listParams$
      .pipe(
        switchMap(params => {
          const refresh$ = params.page === 0
            ? timer(0, 1000)
            : of(0);

          return refresh$.pipe(
            exhaustMap(() =>
              this.commissionJobService
                .getJobList(params.page, params.pageSize, params.filters)
                .pipe(
                  catchError((error: HttpErrorResponse) => {
                    this.snack.open(
                      'Nie udało się pobrać listy akcji',
                      error.status?.toString() ?? '',
                      {duration: 2000}
                    );

                    return EMPTY;
                  })
                )
            )
          );
        }),
        takeUntil(this.destroyed$)
      )
      .subscribe((result: CountedAndPaginated<CommissionJob>) => {
        this.jobs = result.items;
        this.totalData = result.pagination.total;
      });

    this.store
      .pipe(
        select(getCurrentRouteState),
        delay(0),
        distinctUntilChanged(
          (prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url
        ),
        takeUntil(this.destroyed$)
      )
      .subscribe((state: RouterStateUrl) => {
        this.parseFilters(state.params);

        this.paginator.pageIndex = Number(state.params.page ?? 0);
        this.paginator.pageSize = Number(state.params.pageSize ?? 10);

        if (state.params?.billingMonth) {
          this.billingMonthControl.setValue(moment(state.params.billingMonth), {
            emitEvent: false
          });
        }

        this.loadListData();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    filters.billingMonth = this.billingMonthControl.value;

    return filters;
  }

  loadListData(): void {
    this.listParams$.next({
      page: this.paginator.pageIndex,
      pageSize: this.paginator.pageSize,
      filters: this.buildFilters()
    });
  }

  filter(): void {
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
      page: 0,
      pageSize: this.paginator.pageSize,
      billingMonth: this.billingMonthControl.value,
      ...this.filtersForm.value,
    })]);
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
      page: 0,
      pageSize: this.paginator.pageSize,
      billingMonth: this.billingMonthControl.value,
    }]);
  }

  onImgError($event: ErrorEvent): void {
    // @ts-ignore
    $event.target.src = '/assets/avatar.png';
  }

  make(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz uruchomić tę akcję?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        switch (this.actionKeyControl.value) {
          case 'structureUpdate':
            this.commissionJobService.structureUpdate(this.actionForm.value)
              .subscribe(() => {
                this.loadListData();
              }, (error: HttpErrorResponse) => {
                this.snack.open('Blokada uruchomienia akcji', error.status.toString(), {duration: 2000});
                if (error.status === 400) {
                  this.snack.open(error.error.error.text, '400', {duration: 4000});
                }
              });
            // this.actionControl.reset();
            break;
          case 'ratePaidMatch':
            this.commissionJobService.ratePaidMatch(this.actionForm.value)
              .subscribe(() => {
                this.loadListData();
              }, (error: HttpErrorResponse) => {
                this.snack.open('Blokada uruchomienia akcji', error.status.toString(), {duration: 2000});
                if (error.status === 400) {
                  this.snack.open(error.error.error.text, '400', {duration: 4000});
                }
              });
            // this.actionControl.reset();
            break;
          case 'generateSettlements':
            this.commissionJobService.generateSettlements(this.actionForm.getRawValue())
              .subscribe(() => {
                this.loadListData();
              }, (error: HttpErrorResponse) => {
                this.snack.open('Blokada uruchomienia akcji', error.status.toString(), {duration: 2000});
                if (error.status === 400) {
                  this.snack.open(error.error.error.text, '400', {duration: 4000});
                }
              });
            // this.actionControl.reset();
            break;
          case 'closeMonth':
            this.closeMonth();
            break;
          // case 'generateInvoices':
          //   this.generateInvoice();
          //   break;
          case 'generateCommissionStatements':
            this.generateCommissionStatements();
            break;
          case 'sendSettlementsToPartners':
            this.sendSettlementsToPartners();
            break;

          default:
            this.snack.open('Brak obsługi dla wybranej akcji', '', {duration: 2000});
        }
      }
    });
  }

  trackTask(index: number, commissionJob: CommissionJob): string {
    return commissionJob.uuid;
  }

  insuranceCompanyChanged(insuranceCompany?: InsuranceCompany): void {
    this.selectedInsuranceCompany = insuranceCompany;
    if (insuranceCompany) {
      this.commissionImportService.loadImportList(
        0, 1000, {
          insuranceCompany: this.selectedInsuranceCompany?.id,
          billingMonth: this.billingMonthControl.value?.format('YYYY-MM'),
        }, this.importListSubject
      );
    }

    this.importControl.setValue('');
  }

  generateReportFile(commissionJob: CommissionJob, status: string): void {
    this.commissionImportRowService.downloadReport(this.buildFiltersReport(commissionJob, status))
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
        if (error.status === 400) {
          this.snack.open('Obecnie generowany jest raport', '400', {duration: 4000});
        }
      });
  }

  downloadReportFile(commissionJob: CommissionJob): void {
      this.commissionJobService.downloadFile(commissionJob.uuid);
  }
  downloadGroupedCommissionStatementsPdf(commissionJob: CommissionJob): void {
    // if (commissionJob.fileLocation){
    //   this.commissionJobService.downloadGroupedCommissionStatementsPdfFile(commissionJob.uuid)
    // } else {
      this.commissionJobService.downloadGroupedCommissionStatementsPdf(commissionJob.uuid)
        .subscribe((response: Uuid) => {
          this.dialog.open(JobResultDialogComponent, {
            disableClose: true,
            width: '500px',
            data: {
              jobId: response.uuid,
              showProgress: true,
            },
          });
        }, (error: HttpErrorResponse) => {

          this.snack.open('Przy generowaniu zestawienia wystąpił błąd', error.status.toString(), {
            duration: 2000
          });

          if (error.status === 400) {
            this.snack.open(error.error.error.text, '400', {duration: 4000});
          }
        });
    // }
  }

  buildFiltersReport(commissionJob: CommissionJob, status): any {
    const filters = {
      job: commissionJob.uuid,
      insuranceCompany: commissionJob.insuranceCompany?.id ?? '',
      importer: commissionJob.commissionImport?.importer?.id ?? '',
      status: status ?? '',
      ...this.initialFilters};

    return filters;
  }
  closeMonth(): void {
    const billingMonth = this.billingMonthControl.value;

    const dialogRefCheckSettlement = this.dialog.open(JobsListDialogComponent, {
      width: '700px',
      data: {
        billingMonth,
        checkSettlementButton: true,
        partner: this.partnerControl.value,
        ofwca: this.ofwcaControl.value,
      },
    });
    dialogRefCheckSettlement.afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(resultCheckSettlement => {
        if (!resultCheckSettlement) {
          return;
        }

        const dialogRef = this.dialog.open(JobsListDialogComponent, {
          width: '800px',
          data: {
            commissionSettlementService: this.commissionSettlementService,
            billingMonth,
            partner: this.partnerControl.value,
            ofwca: this.ofwcaControl.value,
          },
        });

        dialogRef.afterClosed()
          .pipe(takeUntil(this.destroyed$))
          .subscribe(result => {
            if (!result) {
              this.snack.open(
                'Rozliczenie jest do ponownego wygenerowania lub znajduje się w nim polisa w statusie nowa',
                '',
                {duration: 5000, panelClass: 'textCenter'}
              );
              return;
            }

            this.commissionJobService.closeMonth(this.actionForm.value)
              .pipe(takeUntil(this.destroyed$))
              .subscribe(() => {
                this.loadListData();
              }, (error: HttpErrorResponse) => {
                this.snack.open('Blokada uruchomienia akcji', error.status.toString(), {
                  duration: 2000
                });

                if (error.status === 400) {
                  this.snack.open(error.error.error.text, '400', {duration: 4000});
                }
              });
          });
      });
  }

  generateInvoice(): void {
    const billingMonth = this.billingMonthControl.value;

    const dialogRef = this.dialog.open(JobsListDialogComponent, {
      width: '800px',
      data: {
        billingMonth,
        partner: this.partnerControl.value,
        ofwca: this.ofwcaControl.value,
      },
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(result => {
        if (!result) {
          this.snack.open(
            'Aby wygenerować faktury należy zamknąć rozliczenia',
            '',
            {duration: 2000}
          );
          return;
        }

        this.commissionJobService.generateInvoices(this.actionForm.value)
          .pipe(takeUntil(this.destroyed$))
          .subscribe(() => {
            this.loadListData();
          }, (error: HttpErrorResponse) => {
            this.snack.open(
              'Blokada uruchomienia akcji',
              error.status.toString(),
              {duration: 2000}
            );

            if (error.status === 400) {
              this.snack.open(error.error.error.text, '400', {duration: 4000});
            }
          });
      });
  }
  generateCommissionStatements(): void {
    const billingMonth = this.billingMonthControl.value;

    const dialogRef = this.dialog.open(JobsListDialogComponent, {
      width: '800px',
      data: {
        billingMonth,
        partner: this.partnerControl.value,
        ofwca: this.ofwcaControl.value,
      },
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(result => {
        if (!result) {
          this.snack.open(
            'Aby wygenerować zestawienie prowizyjne należy zamknąć rozliczenia',
            '',
            {duration: 2000}
          );
          return;
        }

        this.commissionJobService.generateCommissionStatements(this.actionForm.value)
          .pipe(takeUntil(this.destroyed$))
          .subscribe(() => {
            this.loadListData();
          }, (error: HttpErrorResponse) => {
            this.snack.open(
              'Blokada uruchomienia akcji',
              error.status.toString(),
              {duration: 2000}
            );

            if (error.status === 400) {
              this.snack.open(error.error.error.text, '400', {duration: 4000});
            }
          });
      });
  }
  sendSettlementsToPartners(): void {
    const billingMonth = this.billingMonthControl.value;

    const dialogRef = this.dialog.open(JobsListDialogComponent, {
      width: '800px',
      data: {
        billingMonth,
        partner: this.partnerControl.value,
        ofwca: this.ofwcaControl.value,
      },
    });

    dialogRef.afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(result => {
        if (!result) {
          this.snack.open(
            'Aby wysłać rozliczenia należy wcześniej je zamknąć',
            '',
            {duration: 2000}
          );
          return;
        }

        this.commissionJobService.sendSettlementsToPartners(this.actionForm.value)
          .pipe(takeUntil(this.destroyed$))
          .subscribe(() => {
            this.loadListData();
          }, (error: HttpErrorResponse) => {
            this.snack.open(
              'Blokada uruchomienia akcji',
              error.status.toString(),
              {duration: 2000}
            );

            if (error.status === 400) {
              this.snack.open(error.error.error.text, '400', {duration: 4000});
            }
          });
      });
  }

  deleteJob(job: CommissionJob): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć akcję?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commissionJobService.deleteJob(job.uuid)
          .subscribe(() => {
            this.snack.open('Pomyślnie usunięto akcję', '', {duration: 2000});
          }, (error: HttpErrorResponse) => {
            this.snack.open('Podczas usuwania akcji wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });
            if (error.status === 400) {
              this.snack.open(error.error.error.text, '400', {duration: 4000});
            }
          });
      }
    });
  }
  zipDownload(job: CommissionJob): void {
    this.commissionJobService.zipDownload(job.uuid)
      .subscribe((response: Uuid) => {
        const dialogRef = this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });

        dialogRef.afterClosed().subscribe(result => {
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu dokumentów wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  checkSettlement(): void {
    const billingMonth = this.billingMonthControl.value;

    this.dialog.open(JobsListDialogComponent, {
      width: '800px',
      data: {
        billingMonth,
        checkSettlement: true,
        partner: this.partnerControl.value,
        ofwca: this.ofwcaControl.value,
      },
    });
  }

  deleteInvoice(job: CommissionJob): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      data: {text: 'Czy na pewno chcesz usunąć faktury?'},
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.commissionJobService.deleteJobInvoice(job.uuid)
          .subscribe((response) => {
           const dialogRef = this.dialog.open(JobResultDialogComponent, {
             disableClose: true,
              width: '500px',
              data: {
                jobId: response.uuid,
                showProgress: true,
                error: 'Nie można usunąć faktur w statusie: zapłacona, wysłana do płatności',
              },
            });
            dialogRef.afterClosed().pipe().subscribe((r) => {
              if (r){
                this.commissionJobService.deleteJob(job.uuid)
                  .subscribe(() => {
                    this.snack.open('Pomyślnie usunięto akcję', '', {duration: 2000});
                  }, (error: HttpErrorResponse) => {
                    this.snack.open('Podczas usuwania akcji wystąpił błąd', error.status.toString(), {
                      duration: 2000,
                    });
                    if (error.status === 400) {
                      this.snack.open(error.error.error.text, '400', {duration: 4000});
                    }
                  });
              }
            });
          }, (error: HttpErrorResponse) => {
            this.snack.open('Podczas usuwania akcji wystąpił błąd', error.status.toString(), {
              duration: 2000,
            });
            if (error.status === 400) {
              this.snack.open(error.error.error.text, '400', {duration: 4000});
            }
          });

      }
    });
  }

  private loadCommissionRedirectionLock(): void {
    this.commissionRedirectionLockLoading = true;

    this.commissionRedirectionLockService
      .get()
      .pipe(
        finalize(() => {
          this.commissionRedirectionLockLoading = false;
        }),
        takeUntil(this.destroyed$),
      )
      .subscribe(
        (lock: CommissionRedirectionLock) => {
          this.commissionRedirectionLock = lock;

          this.commissionRedirectionLockControl.setValue(
            lock.active,
            {emitEvent: false}
          );
        },
        (error: HttpErrorResponse) => {
          this.commissionRedirectionLockControl.disable({
            emitEvent: false
          });

          this.snack.open(
            'Nie udało się pobrać stanu blokady przepięć polis',
            error.status?.toString() ?? '',
            {duration: 3000}
          );
        }
      );
  }

  updateCommissionRedirectionLock(
    event: MatSlideToggleChange
  ): void {
    if (this.commissionRedirectionLockUpdating) {
      return;
    }

    const previousActive =
      this.commissionRedirectionLock.active;

    const active = event.checked;

    let billingMonth: string | null = null;

    if (active) {
      const selectedMonth = moment(
        this.billingMonthControl.value
      );

      if (!selectedMonth.isValid()) {
        this.commissionRedirectionLockControl.setValue(
          previousActive,
          {emitEvent: false}
        );

        this.snack.open(
          'Wybierz prawidłowy miesiąc rozliczeniowy',
          '',
          {duration: 3000}
        );

        return;
      }

      billingMonth = selectedMonth.format('YYYY-MM');
    }

    this.commissionRedirectionLockUpdating = true;

    this.commissionRedirectionLockService
      .update({
        active,
        billingMonth,
      })
      .pipe(
        finalize(() => {
          this.commissionRedirectionLockUpdating = false;
        }),
        takeUntil(this.destroyed$),
      )
      .subscribe(
        () => {
          this.commissionRedirectionLock = {
            active,
            billingMonth: active ? billingMonth : null,
            unlockBillingMonth: active && billingMonth
              ? moment(billingMonth, 'YYYY-MM')
                .add(1, 'month')
                .format('YYYY-MM')
              : null,
          };

          this.commissionRedirectionLockControl.setValue(
            active,
            {emitEvent: false}
          );

          this.snack.open(
            active
              ? 'Włączono blokadę przepięć polis'
              : 'Wyłączono blokadę przepięć polis',
            '',
            {duration: 2500}
          );
        },
        (error: HttpErrorResponse) => {
          this.commissionRedirectionLockControl.setValue(
            previousActive,
            {emitEvent: false}
          );

          const message =
            error.error?.error?.text
            ?? 'Nie udało się zmienić blokady przepięć polis';

          this.snack.open(
            message,
            error.status?.toString() ?? '',
            {duration: 4000}
          );
        }
      );
  }

}
